window.ProductItemForm = {
  toggle: function(button) {
    const card=button.closest('.product-item');
    const form=card?.querySelector('.product-item-form');
    if(!form)return;
    const open=!card.classList.contains('next-quick-open');
    document.querySelectorAll('.product-item.next-quick-open').forEach(item=>{
      item.classList.remove('next-quick-open');
      item.querySelector('.toggle-product-form')?.setAttribute('aria-expanded','false');
    });
    form.classList.remove('hidden');
    card.classList.toggle('next-quick-open',open);
    button.setAttribute('aria-expanded',String(open));
  },

  addToCart: function(formId, variantId = null, event) {
    event.stopPropagation();
    
    console.log('ProductItemForm.addToCart called:', { formId, variantId });
    
    // Check if this is coming from a plus button (single variant case)
    const isPlusButton = event.target.closest('button')?.querySelector('.icon-plus');
    let plusButton = null;
    let plusIcon = null;

    if (isPlusButton) {
      plusButton = event.target.closest('button');
      plusIcon = plusButton.querySelector('.icon-plus');

      // Set loading state for plus button: swap the plus icon for a spinner in place
      plusButton.disabled = true;
      if (plusIcon) plusIcon.style.display = 'none';
      const spinner = document.createElement('span');
      spinner.className = 'icon-plus-spinner w-4 h-4 border border-current border-t-transparent rounded-full animate-spin';
      plusButton.appendChild(spinner);
    }
    
    // Use explicit variant ID if provided, otherwise get from VariantSelector
    let selectedVariantId = variantId;
    
    if (!selectedVariantId && window.VariantSelector) {
      selectedVariantId = window.VariantSelector.getSelectedVariantId(formId);
    }
    
    if (!selectedVariantId) {
      console.error('No variant ID available for product item');
      
      // Reset plus button state if there was an error
      if (plusButton) {
        this.resetPlusButtonState(plusButton, plusIcon);
      }

      return Promise.reject('No variant selected');
    }
    
    console.log('Adding variant to cart:', selectedVariantId);
    
    // Get product info from the product item
    const productItem = event.target.closest('.product-item');
    const productTitle = productItem.querySelector('.next-card-title')?.textContent?.trim();
    
    // Use custom add to cart that shows notification instead of opening cart
    return this.customAddToCart(selectedVariantId, productTitle)
      .then(cart => {
        console.log('Product added to cart successfully:', cart);
        
        // Hide the size picker after adding to cart
        this.hideFormAfterAddToCart(event);
        
        return cart;
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        throw error;
      })
      .finally(() => {
        // Reset plus button state
        if (plusButton) {
          this.resetPlusButtonState(plusButton, plusIcon);
        }
      });
  },
  
  customAddToCart: function(variantId, productTitle) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(async response => {
      const data=await response.json();
      if(!response.ok)throw new Error(data.description||'Unable to add this item.');
      return data;
    })
    .then(data => {
      console.log('Product added to cart:', data);
      
      // Update cart contents immediately
      return fetch('/cart.js');
    })
    .then(response => response.json())
    .then(async cart => {
      // Use centralized cart update function for consistency
      if (window.updateCart) {
        await window.updateCart(cart);
      } else {
        // Fallback to individual functions if updateCart is not available
        if (window.updateMenuCart) {
          window.updateMenuCart(cart);
        }
        if (window.updateMainCart) {
          window.updateMainCart(cart);
        }
        if (window.updateCartCount) {
          window.updateCartCount(cart.item_count);
        }
        
        // Update free shipping progress
        if (window.updateFreeShippingProgress) {
          window.updateFreeShippingProgress(cart);
        }
      }
      
      // Open cart drawer instead of showing notification
      if (window.toggleCartDrawer) {
        window.toggleCartDrawer();
      }
      
      // Show the menu cart footer and notes section immediately
      const menuCartFooter = document.querySelector('.menu-cart-footer');
      const cartNotesSection = document.querySelector('.cart-notes-section');
      if (menuCartFooter) {
        menuCartFooter.style.display = 'block';
      }
      if (cartNotesSection) {
        cartNotesSection.style.display = 'block';
      }
      
      return cart;
    });
  },
  


  fallbackAddToCart: function(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
    .then(async response => {
      const data=await response.json();
      if(!response.ok)throw new Error(data.description||'Unable to add this item.');
      return data;
    })
    .then(data => {
      console.log('Product added to cart:', data);
      
      // Update cart contents immediately
      return fetch('/cart.js');
    })
    .then(response => response.json())
    .then(async cart => {
      // Use centralized cart update function for consistency
      if (window.updateCart) {
        await window.updateCart(cart);
      } else {
        // Fallback to individual functions if updateCart is not available
        if (window.updateMenuCart) {
          window.updateMenuCart(cart);
        }
        if (window.updateMainCart) {
          window.updateMainCart(cart);
        }
        if (window.updateCartCount) {
          window.updateCartCount(cart.item_count);
        }
        
        // Update free shipping progress
        if (window.updateFreeShippingProgress) {
          window.updateFreeShippingProgress(cart);
        }
      }
      
      // Open cart drawer
      if (window.toggleCartDrawer) {
        window.toggleCartDrawer();
      }
      
      // Show the menu cart footer and notes section immediately
      const menuCartFooter = document.querySelector('.menu-cart-footer');
      const cartNotesSection = document.querySelector('.cart-notes-section');
      if (menuCartFooter) {
        menuCartFooter.style.display = 'block';
      }
      if (cartNotesSection) {
        cartNotesSection.style.display = 'block';
      }
      
      return cart;
    });
  },
  
  hideFormAfterAddToCart: function(event) {
    const button = event.target;
    const productItem = button.closest('.product-item');
    const form = productItem.querySelector('.product-item-form');
    const toggleButton = productItem.querySelector('.toggle-product-form');
    
    productItem.classList.remove('next-quick-open');
    toggleButton?.setAttribute('aria-expanded','false');
    if (form && toggleButton) {
      const iconPlus = toggleButton.querySelector('.icon-plus');
      const iconMinus = toggleButton.querySelector('.icon-minus');
      
      form.classList.add('hidden');
      if (iconPlus) iconPlus.style.display = 'block';
      if (iconMinus) iconMinus.style.display = 'none';
    }
  },

  resetPlusButtonState: function(button, plusIcon) {
    // Remove the spinner, restore the plus icon
    const spinner = button.querySelector('.icon-plus-spinner');
    if (spinner) spinner.remove();
    if (plusIcon) plusIcon.style.display = '';

    // Reset button state
    button.disabled = false;
  }
};

// Enhanced event listener for product item variant buttons
document.addEventListener('DOMContentLoaded', function() {
  // Handle variant button clicks specifically for product items with higher priority
  document.addEventListener('click', function(event) {
    const variantButton = event.target.closest('.variant-button');
    
    // Only handle buttons inside product-item-form
    if (variantButton && variantButton.closest('.product-item-form')) {
      event.preventDefault();
      event.stopPropagation();
      
      if (variantButton.disabled || variantButton.dataset.available === 'false') {
        return;
      }
      
      const form = variantButton.closest('.product-item-form');
      const formId = form?.dataset.formId;
      const variantId = variantButton.dataset.variantId;
      
      console.log('Variant button clicked:', { formId, variantId });
      
      if (formId && variantId && window.ProductItemForm) {
        // Set loading state: swap the label for a spinner in place
        const originalHtml = variantButton.innerHTML;
        variantButton.innerHTML = '<span class="icon-plus-spinner inline-block w-3 h-3 border border-current border-t-transparent rounded-full animate-spin"></span>';
        variantButton.disabled = true;
        variantButton.style.opacity = '0.7';

        // Directly add to cart for product items
        window.ProductItemForm.addToCart(formId, variantId, event)
          .catch(error => {
            console.error('Failed to add product item to cart:', error);
          })
          .finally(() => {
            // Reset button state
            variantButton.innerHTML = originalHtml;
            variantButton.disabled = false;
            variantButton.style.opacity = '';
          });
      } else {
        console.error('Missing data for variant button click:', { formId, variantId });
      }
      
      return false; // Prevent any other event handling
    }
  }, true); // Use capture phase to handle before variant-selector.js
}); 
document.addEventListener('click',event=>{
 if(event.target.closest('.product-item'))return;
 document.querySelectorAll('.next-quick-open').forEach(card=>{card.classList.remove('next-quick-open');card.querySelector('.toggle-product-form')?.setAttribute('aria-expanded','false');});
});
document.addEventListener('keydown',event=>{
 if(event.key!=='Escape')return;
 document.querySelectorAll('.next-quick-open').forEach(card=>{card.classList.remove('next-quick-open');const button=card.querySelector('.toggle-product-form');button?.setAttribute('aria-expanded','false');button?.focus();});
});
